// extracted by mini-css-extract-plugin
export default {"item":"ClientAbout_item__QHdRG","link":"ClientAbout_link__KJUHG","title":"ClientAbout_title__u1NZn","image_wrapper":"ClientAbout_image_wrapper__eCNq8"};